import React, { FC } from 'react';
import { ChristmasColors } from './christmasColors';

export interface ChristmasTreeProps {
  /** Height of the tree in px. Width follows the aspect ratio. */
  size?: number;
  /** Lights up the star and the baubles. */
  lit?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const BAUBLES = [
  { cx: 17, cy: 17, color: ChristmasColors.BAUBLE_GOLD },
  { cx: 25, cy: 24, color: ChristmasColors.BAUBLE_BLUE },
  { cx: 14, cy: 27, color: ChristmasColors.BAUBLE_RED },
  { cx: 20, cy: 33, color: ChristmasColors.BAUBLE_GOLD },
  { cx: 11, cy: 36, color: ChristmasColors.BAUBLE_BLUE },
  { cx: 29, cy: 35, color: ChristmasColors.BAUBLE_RED },
];

/** A small hand-drawn SVG Christmas tree with a star and baubles. */
export const ChristmasTree: FC<ChristmasTreeProps> = ({ size = 28, lit = false, className, style }) => {
  const width = Math.round(size * 0.87);
  return (
    <svg
      className={className}
      style={style}
      width={width}
      height={size}
      viewBox='0 0 40 46'
      role='img'
      aria-hidden='true'
      data-testid='ChristmasTree'
      data-lit={lit ? 'true' : 'false'}>
      <defs>
        <radialGradient id='christmasTreeGlow' cx='50%' cy='55%' r='55%'>
          <stop offset='0%' stopColor={ChristmasColors.GLOW} stopOpacity='0.9' />
          <stop offset='100%' stopColor={ChristmasColors.GLOW} stopOpacity='0' />
        </radialGradient>
      </defs>
      {/* trunk */}
      <rect x='17' y='38' width='6' height='8' rx='1' fill={ChristmasColors.TRUNK} />
      {/* tiers, bottom first so the upper tiers overlap */}
      <path d='M20 20 2 39h36z' fill={ChristmasColors.TREE_DARK} />
      <path d='M20 12 5 29h30z' fill={ChristmasColors.TREE} />
      <path d='M20 5 8 20h24z' fill={ChristmasColors.TREE_LIGHT} />
      {lit && <ellipse cx='20' cy='26' rx='20' ry='18' fill='url(#christmasTreeGlow)' />}
      {/* baubles */}
      {BAUBLES.map((bauble) => (
        <g key={`${bauble.cx}-${bauble.cy}`}>
          <circle cx={bauble.cx} cy={bauble.cy} r='2.2' fill={bauble.color} />
          {lit && <circle cx={bauble.cx - 0.7} cy={bauble.cy - 0.7} r='0.8' fill={ChristmasColors.SNOW} />}
        </g>
      ))}
      {/* star */}
      <path
        d='M20 0l1.8 3.8 4.2.6-3 2.9.7 4.1-3.7-2-3.7 2 .7-4.1-3-2.9 4.2-.6z'
        fill={lit ? ChristmasColors.GLOW : ChristmasColors.STAR}
        stroke={ChristmasColors.STAR}
        strokeWidth='0.8'
      />
    </svg>
  );
};

export default ChristmasTree;
